import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5799506"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-0 text-white" }
const _hoisted_2 = { class: "dashboard-content" }
const _hoisted_3 = { class: "p-2 flex items-center justify-between" }
const _hoisted_4 = { class: "m-0 inline-block" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("You are playing ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" in ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path3" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path4" }, null, -1))
const _hoisted_11 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "text-warning" }
const _hoisted_13 = { class: "window-icons inline-block" }
const _hoisted_14 = { class: "p-0 game-container" }
const _hoisted_15 = { class: "game-area" }
const _hoisted_16 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_GamesFeedbackModal = _resolveComponent("GamesFeedbackModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_router_link, {
              to: { name: 'viewGamesDetails', params: { gameId: _ctx.gameId }},
              class: "game-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.title), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _hoisted_6,
            _createElementVNode("span", {
              class: _normalizeClass([_ctx.label=='Testnet'?'xr-test-net':'xr-main-net', "mx-1"])
            }, _hoisted_11, 2),
            _createElementVNode("span", _hoisted_12, [
              _createTextVNode(_toDisplayString(_ctx.label) + " Environment. ", 1),
              _createElementVNode("button", {
                class: "bg-gray-600 hover:bg-red-primary text-white text-sm px-2 py-1 rounded-md font-semibold transition-all duration-200",
                onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.displayFeedbackModal = true;})
              }, "Feedback")
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("i", null, [
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-window-maximize",
                class: "text-gray-text",
                onClick: _ctx.maxScreen
              }, null, 8, ["onClick"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            (_ctx.isFullScreen)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "restore-view",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.restoreView && _ctx.restoreView(...args)))
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-window-restore" })
                ]))
              : _createCommentVNode("", true),
            (_openBlock(), _createElementBlock("iframe", {
              key: _ctx.gameView,
              src: _ctx.gameView,
              class: _normalizeClass(`${_ctx.isFullScreen?'fullScreen':'defaultScreen'}`),
              scrolling: "auto",
              border: "0",
              frameBorder: "0",
              allowfullscreen: "true"
            }, null, 10, _hoisted_16))
          ])
        ])
      ])
    ]),
    _createVNode(_component_GamesFeedbackModal, {
      gameId: _ctx.gameId,
      title: _ctx.title,
      displayFeedbackModal: _ctx.displayFeedbackModal,
      onCloseFeedbackModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.displayFeedbackModal = false))
    }, null, 8, ["gameId", "title", "displayFeedbackModal"])
  ]))
}